import React from 'react';
import { Link } from 'react-router-dom';
import { 
  ArrowLeft, 
  HelpCircle, 
  Activity, 
  Mail, 
  FileText, 
  Shield,
  Scale,
  Lock,
  ExternalLink,
  ChevronRight
} from 'lucide-react';

function SupportLegal() {
  const supportItems = [
    {
      title: 'Help Centre',
      description: 'Find answers to common questions',
      icon: HelpCircle,
      link: '/support/help',
      type: 'internal'
    },
    {
      title: 'System Status',
      description: 'View your organisation\'s system health',
      icon: Activity,
      link: '/support/status',
      type: 'internal'
    },
    {
      title: 'Contact Support',
      description: 'Get help from our support team',
      icon: Mail,
      link: '/support/contact',
      type: 'internal'
    },
    {
      title: 'Audit & Access Log',
      description: 'View support access history',
      icon: FileText,
      link: '/support/access-log',
      type: 'internal'
    }
  ];

  const legalItems = [
    {
      title: 'Terms of Service',
      description: 'Our terms and conditions',
      icon: Scale,
      link: '/legal/terms',
      type: 'internal'
    },
    {
      title: 'Privacy Policy',
      description: 'How we handle your data',
      icon: Shield,
      link: '/legal/privacy',
      type: 'internal'
    },
    {
      title: 'AI Use & Limitations',
      description: 'AI capabilities and boundaries',
      icon: Lock,
      link: '/legal/ai-use',
      type: 'internal'
    },
    {
      title: 'Data Processing Agreement',
      description: 'GDPR compliance documentation',
      icon: FileText,
      link: '#',
      type: 'placeholder',
      note: 'Available on request'
    }
  ];

  return (
    <div className="support-page" data-testid="support-legal-page">
      <div className="support-container">
        <Link to="/command-centre" className="support-back-link">
          <ArrowLeft size={16} />
          Back to Command Centre
        </Link>

        <div className="support-header">
          <div className="support-icon">
            <Shield size={28} />
          </div>
          <h1>Support & Legal</h1>
          <p className="support-subtitle">
            Help resources, system status, and legal documentation
          </p>
        </div>

        {/* Support Section */}
        <div className="support-section" data-testid="support-section">
          <h2 className="section-title">Support</h2>
          <div className="support-grid">
            {supportItems.map((item, index) => (
              <Link 
                key={index} 
                to={item.link} 
                className="support-item-card"
                data-testid={`support-item-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div className="item-icon">
                  <item.icon size={22} />
                </div>
                <div className="item-content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
                <ChevronRight size={18} className="item-arrow" />
              </Link>
            ))}
          </div>
        </div>

        {/* Legal Section */}
        <div className="support-section" data-testid="legal-section">
          <h2 className="section-title">Legal</h2>
          <div className="support-grid">
            {legalItems.map((item, index) => (
              item.type === 'placeholder' ? (
                <div key={index} className="support-item-card disabled">
                  <div className="item-icon">
                    <item.icon size={22} />
                  </div>
                  <div className="item-content">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                    {item.note && <span className="item-note">{item.note}</span>}
                  </div>
                </div>
              ) : (
                <Link 
                  key={index} 
                  to={item.link} 
                  className="support-item-card"
                  data-testid={`legal-item-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <div className="item-icon">
                    <item.icon size={22} />
                  </div>
                  <div className="item-content">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                  <ChevronRight size={18} className="item-arrow" />
                </Link>
              )
            ))}
          </div>
        </div>

        {/* Trust Notice */}
        <div className="support-trust-notice" data-testid="trust-notice">
          <Shield size={18} />
          <div>
            <p><strong>Your data is protected.</strong></p>
            <p>
              TradeLife support can only access technical system status — never your financial data or documents. 
              Any access is logged and visible to you.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupportLegal;
